import { render } from "./EditUser.vue?vue&type=template&id=13a50aaa"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"
script.render = render

export default script